

























































import { Collection } from '@/resource/collection/collection.model';
import { Component, Vue, Prop } from 'vue-property-decorator';
import ModalDelete from '@/components/modals/ModalDelete.vue';
import ModalUploadQuestion from '@/components/modals/modal-upload-question/ModalUploadQuestion.vue';
import ButtonWithIcon from '@/components/common/ButtonWithIcon.vue';
import VueRouter from 'vue-router';

@Component({
  components: {
    ModalDelete,
    ModalUploadQuestion,
    ButtonWithIcon,
  },
})
export default class CollectionOption extends Vue {
  $router!: VueRouter;

  @Prop()
  collection!: Collection;

  @Prop()
  disableCollectionOption!: boolean;

  @Prop()
  disableAddOwnQuestion!: boolean;

  @Prop()
  isParentLoading!: boolean;

  @Prop()
  openRearrangePositions!: () => void;

  @Prop()
  openGeneratePdf!: () => void;

  showUploadQuestion = false;

  showDeleteCollection = false;
  deleteTitle = 'Delete collection';
  deleteDescription = `Are you sure you want to delete this collection? 
  You will not be able to recover this collection.`;

  createPdfClicked() {
    this.openGeneratePdf();
  }

  deleteCollectionClicked() {
    if (this.isParentLoading) return;

    this.showDeleteCollection = true;
  }

  rearrangePositionsClicked() {
    this.openRearrangePositions();
  }

  closeCollectionDelete(isDeleted = false) {
    if (isDeleted) {
      this.$router.push({
        name: 'collections',
      });
    }
    this.showDeleteCollection = false;
  }

  uploadCollectionClicked() {
    if (this.isParentLoading) return;

    this.showUploadQuestion = true;
  }

  closeUploadQuestion() {
    this.showUploadQuestion = false;
  }
}
